import { createAction } from "redux-actions"

import { NOTIFICATION_ERROR_MESSAGE } from "../constants/ActionTypes"

export const createErrorNotification = createAction<string>(
  NOTIFICATION_ERROR_MESSAGE
)
